export const basePathIcons = 'assets/images';
